// Exports the "insertdatetime" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/insertdatetime')
//   ES2015:
//     import 'tinymce/plugins/insertdatetime'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/insertdatetime/index.js
// module id = 603
// module chunks = 0